<template>
  <div class="contact-main-block w-100 relative">
    <HeaderMenu
      :title="$_mobile ? $t('general.hello') + ' ' + getUserName : title"
      :routeBackName="$_mobile ? '' : routeBackName"
      :class="{ 'mrg-b-30': !$store.state.hasInternet }"
    />
    <div>
      <div class="contact-support-team">
        <div class="contact-support" style="padding-top: 0px">
          <div class="mrg-b-6 bold main-title">
            {{ this.$t("myLicense.OH_license") }}
            <div
              class="not-connected"
              v-if="mainEditionDesc != '' && !this.hasOtzarConnection"
            >
              ({{ $t("login.notConnectedNow") }})
            </div>
          </div>
          <div v-if="mainEditionDesc != ''">
            <div v-if="mainEditionDesc != ''" class="title">
              {{ $t("myLicense.edition") }}:
            </div>
            <div v-if="mainEditionDesc != ''">{{ mainEditionDesc }}</div>

            <div class="seperator"></div>
            <div class="title">{{ $t("myLicense.start") }}:</div>
            <div>{{ periodStartStr }}</div>
            <div class="title">{{ $t("myLicense.end") }}:</div>
            <div>{{ periodEndStr }}</div>
            <!--    <div class="seperator"></div> -->
            <div class="stations-title" v-if="userType.ipUser()">
              {{ `${$t("managePanel.maxStations")} ${otzarStations}` }}
            </div>
          </div>
          <div v-else>
            {{ $t("myLicense.noLic") }}
          </div>
        </div>

        <div
          style="padding: 5px"
          v-if="!userType.ipUser() && tickets.length > 0"
          class="contact-support flex-c"
        >
          <div class="seperator"></div>
          <div class="mrg-b-12 bold main-title">
            {{
              tickets.length == 1
                ? $t("myLicense.youHaveViewTicket")
                : $t("myLicense.youHaveViewTickets")
            }}
          </div>
          <div v-for="ticket in tickets" :key="ticket.id">
            <div style="padding: 0px 20px 0px 20px">{{ ticket.info }}</div>
            <div style="padding: 5px; font-weight: 500">
              {{ $t("myLicense.youHaveLeft") }} {{ ticket.daysLeft }}
              {{ $t("general.outof") }} {{ ticket.days }}
            </div>

            <div
              :class="{ disable: activatedTickets[ticket.id] }"
              v-tooltip="
                activatedTickets[ticket.id]
                  ? { content: $t('myLicense.dayActualized') }
                  : false
              "
              style="margin: auto"
              class="btn btn-larg btn-center"
              @click="doActualizeDay(ticket.id)"
            >
              {{ $t("myLicense.actualizeDay") }}
            </div>
            <div class="seperator"></div>
          </div>
        </div>

        <div></div>

        <div class="contact-support" style="padding-top: 20px">
          <div class="seperator"></div>
          <div class="mrg-b-6 bold main-title">
            {{ $t("myLicense.MEF_license") }}
            <div class="not-connected" v-if="mef && !this.hasMefConnection">
              ({{ $t("login.notConnectedNow") }})
            </div>
          </div>
          <div v-if="!mef">
            {{ $t("myLicense.noLic") }}
          </div>
          <div v-else>
            <div class="title">{{ $t("myLicense.start") }}:</div>
            <div>{{ formatDate(mef.periodStart) }}</div>
            <div class="title">{{ $t("myLicense.end") }}:</div>
            <div>{{ formatDate(mef.periodEnd) }}</div>
            <!-- <div class="seperator"></div> -->
            <div class="stations-title" v-if="userType.ipUser()">
              {{ `${$t("managePanel.maxStations")} ${mefStations}` }}
            </div>
          </div>
        </div>

        <div
          class="contact-support"
          style="padding-top: 20px"
          v-if="packages.size > 0"
        >
          <div class="seperator"></div>
          <div class="mrg-b-6 bold main-title">
            {{ $t("myLicense.packages") }}:
          </div>
          <div v-for="(p, index) in packages" :key="index">
            {{ getPackageDesc(p) }}
          </div>
        </div>

        <div v-if="prints > 0" class="contact-support">
          <div class="seperator"></div>
          <div class="mrg-b-6 bold main-title">
            {{ $t("myLicense.printLicense") }}
          </div>
          <div class="title">{{ $t("myLicense.amount") }}:</div>
          <div>
            {{ printsLeft }} / {{ prints }} {{ $t("myLicense.prints") }}
          </div>
        </div>
      </div>
    </div>
    <div class="ip-info">
      {{ IP }}
    </div>
  </div>
</template>

<script>
// import menuService from "../../../../services/menu";
// import * as userSendEmail from "@/services/userSendEmail.js";
import general from "@/config/general.js";
import { permissionsEnum } from "@/services/license.js";
import { getUserLicenseInfo, actualizeDay } from "@/services/online/license.js";
import moment from "moment";
import { mapGetters } from "vuex";
import Vue from "vue";
export default {
  data() {
    return {
      title: this.$t("myProfile.myLicense"),
      routeBackName: "myProfile",
      mainEdition: "",
      packages: new Set(),
      printCode: "",
      prints: 0,
      printsLeft: 0,
      periodStart: "",
      periodEnd: "",
      tickets: [],
      mef: { periodStart: null, periodEnd: null },
      IP: "",
      otzarStations: 0,
      mefStations: 0,
      activatedTickets: {},
      didActualize: false,
    };
  },
  computed: {
    ...mapGetters("user", [
      "hasOtzarConnection",
      "hasMefConnection",
      "getUserName",
    ]),
    disabledTooltip() {},
    mainEditionDesc() {
      let editionData = permissionsEnum[this.mainEdition];
      return editionData ? editionData.description : "";
    },
    periodStartStr() {
      return moment(this.periodStart).format("DD.MM.YYYY / HH:mm");
    },
    periodEndStr() {
      return moment(this.periodEnd).format("DD.MM.YYYY / HH:mm");
    },
  },
  methods: {
    formatDate(dt) {
      return moment(dt).format("DD.MM.YYYY / HH:mm");
    },
    async doActualizeDay(saleId) {
      if (this.didActualize) return;
      if (this.activatedTickets[saleId]) return;

      if (await actualizeDay(saleId)) {
        this.didActualize = true;
        getUserLicenseInfo().then((data) => {
          if (!data) return;
          this.parseLicenseData(data);
        });
      } else alert("תקלה");
    },
    getPackageDesc(p) {
      return permissionsEnum[p]
        ? p == "CHABAD"
          ? permissionsEnum[p].description2
          : permissionsEnum[p].description
        : "";
    },
    parseLicenseData(data) {
      //IP for support

      this.IP = data.IP || "";

      //print data
      this.printCode = data.printCode;
      this.prints = data.prints;
      this.printsLeft = data.prints - data.printsUsed;

      //main edition and packages
      let protectionData = this.parseProtectionCode(data.permissions);
      this.mainEdition = protectionData.mainEdition;
      this.periodStart = protectionData.periodStart;
      this.periodEnd = protectionData.periodEnd;
      this.packages = protectionData.packages;
      this.mef = protectionData.mef;
      this.otzarStations = data.stations;
      this.mefStations = data.mefStations;
      data.tickets.forEach((t) => {
        let protectionData = this.parseProtectionCode([
          { protectionCode: t.license, validFrom: "", validTo: "" },
        ]);
        t.info = permissionsEnum[protectionData.mainEdition].description + ", ";

        protectionData.packages.forEach(
          (p) =>
            (t.info +=
              (permissionsEnum[p]
                ? p == "CHABAD"
                  ? permissionsEnum[p].description2
                  : permissionsEnum[p].description
                : "") + ", ")
        );

        t.info = t.info.slice(0, t.info.length - 2);
      });

      this.tickets = data.tickets;
    },
    parseProtectionCode(permissions) {
      let mainEdition = "",
        packages = new Set(),
        periodStart,
        periodEnd,
        mef = false;

      //main edition
      permissions.forEach((permission) => {
        if (permission.ticketSaleId != null)
          Vue.set(this.activatedTickets, permission.ticketSaleId, true);
        if ((permission.protectionCode & general.licensePackages.FULL) > 0) {
          if (
            (permission.protectionCode & general.licensePackages.NO_BT) ==
            0
          ) {
            mainEdition = "BT";
          } else mainEdition = "GENERAL";
        } else if (
          (permission.protectionCode & general.licensePackages.CHABAD) >
          0
        ) {
          mainEdition = "CHABAD";
        } else if (
          (permission.protectionCode & general.licensePackages.SCHOOL) >
          0
        ) {
          mainEdition = "SCHOOL";
        }

        //mef otzar
        if ((permission.protectionCode & general.licensePackages.MEF_OTZAR) > 0)
          mef = {
            periodStart: permission.validFrom,
            periodEnd: permission.validTo,
          };

        //license time
        periodStart = permission.validFrom;
        periodEnd = permission.validTo;

        //now packages
        if ((permission.protectionCode & general.licensePackages.KOOK) > 0)
          packages.add("KOOK");
        if ((permission.protectionCode & general.licensePackages.MACHON) > 0)
          packages.add("MACHON");
        if ((permission.protectionCode & general.licensePackages.SHLOMO) > 0)
          packages.add("SHLOMO");
        if ((permission.protectionCode & general.licensePackages.SHALOM) > 0)
          packages.add("SHALOM");
        if ((permission.protectionCode & general.licensePackages.OFEK) > 0)
          packages.add("OFEK");
        if ((permission.protectionCode & general.licensePackages.OZ) > 0)
          packages.add("OZ");
        if ((permission.protectionCode & general.licensePackages.AHARON) > 0)
          packages.add("AHARON");
        if ((permission.protectionCode & general.licensePackages.OVADIA) > 0)
          packages.add("OVADIA");
        if ((permission.protectionCode & general.licensePackages.YESHARIM) > 0)
          packages.add("YESHARIM");
        if ((permission.protectionCode & general.licensePackages.OZ_NEW) > 0)
          packages.add("OZ_NEW");
        if (
          (permission.protectionCode & general.licensePackages.CHABAD) > 0 &&
          mainEdition != "CHABAD"
        )
          packages.add("CHABAD");
      });
      return { mainEdition, packages, periodStart, periodEnd, mef };
    },
  },
  created() {
    getUserLicenseInfo().then((data) => {
      if (!data) return;
      this.parseLicenseData(data);
    });
  },
  mounted() {
    this.didActualize = false;
  },
  destroyed() {
    this.didActualize = false;
  },
};
</script>

<style lang="scss" scoped>
$bg-color2: #f7f7f7;
$bg-color5: #f4f4f4;
.colum1 {
  .row {
    margin-bottom: 12px;
  }
}
.btn-center {
  margin-top: 10px;
}
.flex-c {
  display: flex;
  align-items: center;
  flex-direction: column;
}
.seperator {
  margin: 10px;
  //padding: 10px;
  width: 90%;
}
.main-title {
  font-size: 17px;
}
.title {
  font-size: 16px;
  padding-top: 5px;
  font-weight: 600;
}
.stations-title {
  font-size: 16px;
  padding-top: 5px;
}
.go-to-company-staff-block {
  display: flex;
  margin-top: auto;
  height: 60px;
  background-color: $bg-color5;
  border-top: 1px solid #dedede;
  height: 60px;
  background-color: $bg-color5;
  border: 1px solid #dedede;
  padding: 0 20px;
  position: absolute;
  width: 100%;
  bottom: 0;
  justify-content: space-between;
  p {
    margin: 0;
    line-height: 60px;
    font-weight: bold;
  }
}
.go-to-comp-staff-btn {
  width: auto;
  padding: 0 10px;
  // margin: 3px 0;
  // margin-right: auto;
}
.company-details-block {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .company-location-block {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 30px;
    padding-right: 20px;
    .company-location {
      display: flex;
      flex-direction: column;
      line-height: 0px;
      p {
        margin: 0;
        line-height: 18px;
        font-size: 13px;
      }
    }
    .icon-location {
      display: flex;
      font-size: 100px;
      margin-top: 8px;
      width: 50px;
      opacity: 0.5;
    }
  }
  .company-activity-block {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 30px;
    padding-right: 20px;
    .icon-activity {
      display: flex;
      font-size: 100px;
      margin-top: 8px;
      width: 50px;
      opacity: 0.5;
    }
    .company-activity {
      display: flex;
      flex-direction: column;
      line-height: 0px;
    }
    p {
      margin: 0;
      line-height: 18px;
      font-size: 13px;
    }
  }
  .company-contant-block {
    display: flex;
    justify-content: flex-start;
    padding-right: 20px;
    margin-bottom: 30px;
    .icon-contant {
      display: flex;
      font-size: 100px;
      margin-top: 8px;
      width: 50px;
      opacity: 0.5;
    }
    .company-contant {
      display: flex;
      flex-direction: column;
      line-height: 0px;
    }
    p {
      margin: 0;
      line-height: 18px;
      font-size: 13px;
    }
  }
}
.email-error {
  color: red;
  padding: 0 20px;
}

.contact-container {
  display: flex;
  padding: 0px 10px 0px 10px;
  overflow: auto;
  box-sizing: border-box;
  width: 100%;
  padding: 34px 20px 0px;
  input.input-border.filled + span {
    margin-bottom: 20px !important;
  }
  input.input-border.filled + span span {
    height: 14px;
    line-height: 14px;
    font-size: 10px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.3);
  }
  .input-border.filled:focus + span span {
    color: var(--custom-color1);
  }
}
.input-data {
  width: 90%;
  display: flex;
  border: none;
  //margin: 0px 4px 0px 0px;
  border-bottom: 1px solid #afafaf;
  background: none;
  padding: 0;
  margin-left: 18px;
  //width: -webkit-fill-available;
}

.send-block {
  display: flex;
  justify-content: space-between;
  margin: 0 6px;
}
.send-email {
  margin-right: auto;
  margin-left: 20px;
}
.text-area-container {
  padding: 0 20px 0;
  p {
    margin: 0;
    font-weight: 300;
    color: var(--custom-color1);
    font-size: 12px;
    padding-bottom: 10px;
    font-weight: bold;
  }
  .inputs-data-bloke {
    resize: none;
    width: 97%;
    height: 150px;
    // margin: 6px;
    line-height: 20px;
    background-color: $bg-color2;
    // margin-top: 3px;
    border: 1px solid #afafaf;
    // margin-bottom: 13px;
    &::placeholder {
      color: var(--text-color3) !important;
    }
  }
}
.waiting {
  display: flex;
  justify-content: center;
  font-weight: bold;
  padding-top: 40px;
  font-size: 32px;
}
.contact-support-team {
  //     display: flex;
  //   justify-content: center;
  //   font-weight: bold;
  padding-top: 40px;
  //   font-size: 32px;
  text-align: center;
  color: var(--custom-color1);
  &.code-support {
    font-size: 22px;
  }
}
.contact-support {
  display: flex;
  justify-content: center;
  //   font-weight: bold;
  padding-top: 50px;
  font-size: 16px;
  flex-direction: column;
  align-items: center;
  color: var(--custom-color2);
}
.ip-info {
  bottom: 0;
  position: absolute;
  color: lightgrey;
}
.not-connected {
  color: red;
  font-size: 14px;
}
</style>
